import { Mapper } from "planning-portal-library/src/lib/core/base";
import { ProductActivity } from "planning-portal-library/src/lib/core/domain/models/product-activity";
import { ProductActivityWebEntity } from "./product-activity-web-entity";

export class ProductActivityWebRepositoryMapper extends Mapper<ProductActivityWebEntity, ProductActivity> {
    mapFrom(param: ProductActivityWebEntity): ProductActivity {
      return {
        id: param.id,
        name: param.name,
        description: param.description,
        productId: param.productId,
      };
    }
  
    mapTo(param: ProductActivity): ProductActivityWebEntity {
      return {
        id: param.id,
        name: param.name,
        description: param.description,
        productId: param.productId,
      };
    }
  }
  